import { FormField, TextInput } from "grommet";
import React from "react";

const TextFormField = ({
  label,
  id,
  handleChange,
  handleBlur,
  touched,
  values,
  errors,
}: {
  label: string;
  id: string;
  handleChange: any;
  handleBlur: any;
  touched: any;
  values: any;
  errors: any;
}) => (
  <FormField label={label} error={touched[id] && errors[id]} required>
    <TextInput
      id={id}
      type="text"
      value={values[id]}
      onChange={handleChange}
      onBlur={handleBlur}
    />
  </FormField>
);

export default TextFormField
